import React, { Component } from 'react';
import { Card, CardBody, Badge, Button, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import { Line } from 'react-chartjs-2';
import moment from 'moment';

import Config from '../../config';
import Lang from '../../languages';

import './Daterangepicker.css';

class Statistics extends Component {
 constructor(props) {
  super(props);

  this.state = {
   groupBy: 'events',
   groupDropdown: false,
   startDate: moment().startOf('year'),
   endDate: moment().endOf('year'),
   results: []
  };

  this.update = this.update.bind(this);
 }

 update() {
  this.props.reqAPI(Config.apiURI + '/api/tickets/stats', 'POST', {
   groupBy: this.state.groupBy,
   startDate: this.state.startDate.format('YYYY-MM-DD'),
   endDate: this.state.endDate.format('YYYY-MM-DD')
  }).then(results => {
   this.setState({ results });
  });

 }

 capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
 }

 componentDidMount() {
  this.update();
 }

 render() {
  moment.locale(Lang[this.props.session.language].locale);

  let labels = [];
  let dataset = { sales: [], bookings: [], cancellations: [] };
  this.state.results.map(data => {
   if(data.name) {
    labels.push([data.name, this.capitalizeFirstLetter(data.label)]);
   } else {
    labels.push(this.capitalizeFirstLetter(data.label));
   }
   dataset.sales.push(data.sales);
   dataset.bookings.push(data.bookings);
   dataset.cancellations.push(data.cancellations);
  });

  return <Card>
   <CardBody>
    <Badge color="light"><strong>{Lang[this.props.session.language].Dashboard.labels.total}</strong></Badge>
    <Badge color="success"><strong>{Lang[this.props.session.language].Dashboard.labels.sales}:</strong> {dataset.sales.reduce((partialSum, a) => partialSum + parseInt(a), 0)}</Badge>
    <Badge color="primary"><strong>{Lang[this.props.session.language].Dashboard.labels.bookings}:</strong> {dataset.bookings.reduce((partialSum, a) => partialSum + parseInt(a), 0)}</Badge>
    <Badge color="danger"><strong>{Lang[this.props.session.language].Dashboard.labels.cancellations}:</strong> {dataset.cancellations.reduce((partialSum, a) => partialSum + parseInt(a), 0)}</Badge>
    <Badge><strong>{this.state.startDate.format('LL')}</strong> - <strong>{this.state.endDate.format('LL')}</strong></Badge>
    
    <DateRangePicker containerStyles={{ 'float': 'right' }}
     opens="left"
     startDate={this.state.startDate}
     endDate={this.state.endDate}
     ranges={Lang[this.props.session.language].Dashboard.ranges}
     locale={{
      format: 'DD/MM/YYYY',
      applyLabel: Lang[this.props.session.language].Dashboard.buttons.applyLabel,
      cancelLabel: Lang[this.props.session.language].Dashboard.buttons.cancelLabel,
      customRangeLabel: Lang[this.props.session.language].Dashboard.buttons.customRangeLabel,
      fromLabel: Lang[this.props.session.language].Dashboard.buttons.fromLabel,
      toLabel: Lang[this.props.session.language].Dashboard.buttons.toLabel,
      weekLabel: "W",
      daysOfWeek: moment.weekdaysShort(true),
      monthNames: moment.months(),
      firstDay: 1
     }}
     onApply={(e, picker) => {
      this.setState({
       startDate: picker.startDate,
       endDate: picker.endDate
      }, this.update);
     }}>
     <Button color="primary"><i className="fa fa-calendar"></i></Button>
    </DateRangePicker>
    <Dropdown className="float-right" isOpen={this.state.groupDropdown} toggle={() => { this.setState({ groupDropdown: !this.state.groupDropdown }) }} direction="down">
     <DropdownToggle caret>
      {Lang[this.props.session.language].Dashboard.groups[this.state.groupBy]}
     </DropdownToggle>
     <DropdownMenu container="body">
      {
       Object.keys(Lang[this.props.session.language].Dashboard.groups).map((value, key) => {
        if(!['operators','providers'].includes(value)) {
         return <DropdownItem key={key} onClick={() => { this.setState({ groupBy: value }, this.update) }}>{Lang[this.props.session.language].Dashboard.groups[value]}</DropdownItem>
        } else if(this.props.session.permissions.users[value]) {
         return <DropdownItem key={key} onClick={() => { this.setState({ groupBy: value }, this.update) }}>{Lang[this.props.session.language].Dashboard.groups[value]}</DropdownItem>
        }
       })
      }
     </DropdownMenu>
    </Dropdown>
   </CardBody>
   <CardBody>
    <Line data={{
     labels: labels,
     datasets: [
      {
       fill: true,
       lineTension: 0.1,
       label: Lang[this.props.session.language].Dashboard.labels.cancellations,
       data: dataset.cancellations,
       borderColor: 'rgb(255, 99, 132)',
       backgroundColor: 'rgba(255, 99, 132, 0.5)',
      },
      {
       fill: true,
       lineTension: 0.1,
       label: Lang[this.props.session.language].Dashboard.labels.bookings,
       data: dataset.bookings,
       borderColor: 'rgb(53, 162, 235)',
       backgroundColor: 'rgba(53, 162, 235, 0.5)',
      },
      {
       fill: true,
       lineTension: 0.1,
       label: Lang[this.props.session.language].Dashboard.labels.sales,
       data: dataset.sales,
       borderColor: 'rgb(57, 166, 57)',
       backgroundColor: 'rgba(57, 166, 57, 0.5)',
      }
     ],
    }} options={{
     scales: {
      yAxes: [{
       ticks: {
        stepSize: 1,
        beginAtZero: true
       }
      }]
     }
    }} legend={{
     display: true,
     position: 'bottom',
     fullWidth: true,
     reverse: false,
     labels: {
      fontColor: 'rgb(255, 99, 132)'
     }
    }} height={50} />
   </CardBody>
  </Card>
 }
}

export default Statistics;


// WEBPACK FOOTER //
// ./websources/views/Dashboard/Statistics.js